import localData from "site/common/localData";
import { basketFromUriParams } from "./basket-url-params";

/*eslint-disable */
define(function (require) {
  "use strict";

  var Backbone = require("backbone"),
    _ = require("underscore"),
    $ = require("jquery"),
    config = require("common/page-config");

  var BasketModel = Backbone.Model.extend({
    EXPIRY_PERIOD: config.venueBasketExpiryMinutes * 60 * 1000,

    constructor : function ( attributes, options ) {
        Backbone.Model.apply(this, arguments);

        // If basket URL params are present,
        // persist them in the venue's local storage basket
        const basket = basketFromUriParams();
        if (basket.services && basket.services.length > 0) {
          this.set("services", basket.services);
          this.set("employeeId", basket.employeeId);
          this.setLocalStorage();
        }
      },

    fetch: function () {
      // get information from localStorage
      var venueData = this.getLocalStorage();

      // if venueDate update model
      if (venueData && venueData.services) {
        this.set({
          services: venueData.services,
        });
        this.set({
          employeeId: venueData.employeeId,
        });
      }

      var deferred = new $.Deferred();
      deferred.resolve(this.toJSON());
      return deferred.promise();
    },

    getKey: function () {
      return "venue-basket-" + this.get("venueId");
    },

    getService: function (service) {
      var modelServices = this.get("services");
      return _.where(modelServices, { serviceId: service.serviceId });
    },

    getEmployeeId: function () {
      return this.get("employeeId");
    },

    emptyServices: function () {
      this.set("services", []);
      this.setLocalStorage();
    },

    updateService: function (service) {
      var newServices = [],
        serviceExists = false,
        basket = this.getLocalStorage();

      if (basket.services.length > 0) {
        newServices = _.map(basket.services, function (basketService) {
          if (service.serviceId === basketService.serviceId) {
            serviceExists = true;
            return service;
          }

          return basketService;
        });
      }

      if (!serviceExists) {
        newServices.push(service);
      }

      // add service to model's services
      this.set("services", newServices);
      // update localStorage
      this.setLocalStorage();
    },

    getSummary: function () {
      var summary = {
        count: 0,
        total: 0,
        isFrom: false,
      };

      // calculate total price
      _.each(this.get("services"), function (offer) {
        if (!offer.skus) {
          return false;
        }

        summary.total = _.reduce(
          offer.skus,
          function (memo, item) {
            if (item.isFrom) {
              summary.isFrom = true;
            }

            // update number of skus
            summary.count++;

            return memo + item.price;
          },
          summary.total
        );
      });

      return summary;
    },

    getLocalStorage: function () {
      var basket = JSON.parse(localData.getItem(this.getKey())) || {
        services: [],
      };

      if (basket.updated) {
        var basketExpiresAt = basket.updated + this.EXPIRY_PERIOD;
        var now = new Date().getTime();

        if (now > basketExpiresAt) {
          basket.services = [];
          this.set("services", []);
          this.setLocalStorage();
        }
      }

      return basket;
    },

    setLocalStorage: function () {
      var basket = {
        services: this.get("services"),
        employeeId: this.get("employeeId"),
        updated: new Date().getTime(),
      };

      if (basket.services.length === 0) {
        localData.removeItem(this.getKey());
        return;
      }

      localData.setItem(this.getKey(), JSON.stringify(basket));
    },
  });

  return BasketModel;
});
